import { IoIosArrowDown } from "react-icons/io";

const InputSelect = ({ title, placeholder }) => {
  return (
    <div className="mt-8">
      <p className="mb-4 font-pop text-[22px] font-semibold text-darkGreen">
        {title}
      </p>

      <div className="mb-2 grid grid-cols-5 items-stretch">
        <input
          type="text"
          className=" col-span-4 box-border  rounded border border-lightGray px-8 py-[22px] font-pop text-lg  text-black text-opacity-50 outline-none"
          placeholder={placeholder || ""}
        />
        <button className="box-border flex grow items-center justify-center border border-l-0 border-lightGray bg-primary text-3xl text-white">
          <IoIosArrowDown className="h-10 w-10" />
        </button>
      </div>
    </div>
  );
};

export default InputSelect;
